module.exports = __webpack_public_path__ + "static/media/altros-symbol-name.2dd63ac5.png";